<template>
    <a-modal
        :title="title"
        :width="1000"
        :ok=false
        :visible="visible"
        :maskClosable="maskClosable"
        @cancel="handleCancel"

        :cancelText="$t('关闭')">
        <template slot="footer">
            <a-button key="close" @click="handleCancel">
                {{ $t('关闭') }}
            </a-button>
        </template>
              <a-card :bordered="false">
                <!-- table区域-begin -->
                <div>
                <a-table
                    ref="table"
                    size="middle"
                    :scroll="{x:true}"
                    bordered
                    rowKey="id"
                    :columns="columns"
                    :dataSource="dataSource"
                    :pagination="ipagination"
                    :loading="loading"
                    class="j-table-force-nowrap"
                    @change="handleTableChange"
                    >
                </a-table>
                </div>
            </a-card>
    </a-modal>
</template>
<script>
import {isUndefined} from'@/utils/validate'
import { getAction } from '../../../api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

    export default {
        mixins:[JeecgListMixin],
        data() {
            return {
                list: [],
                visible: false,
                maskClosable: false,
                model: {},
                disableMixinCreated: true,
                loading: false,
                url: {
                    list: '/jeecg-charge/meter/meterFotaCommand/list'
                }
            }
        },
        computed: {
            // i18n：弹窗标题/表头使用 computed 以响应语言切换
            title() {
                return this.$t('命令详情')
            },
            columns() {
                return [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:(t,r,index) => {
                        return parseInt(index)+1;
                        }
                    },{
                        title: this.$t('状态'),
                        align:"center",
                        dataIndex: 'status',
                        customRender:(t,r,index) => {
                            let obj = {0: this.$t('未发送'),1: this.$t('已发送'),2: this.$t('发送成功'),3: this.$t('读/写命令返回信息成功'),4: this.$t('取消命令'),'-1': this.$t('发送失败')}
                            if(isUndefined(obj[t])) {
                                return this.$t('未知')
                            }
                            return obj[t]
                        }
                    },{
                        title: this.$t('命令参数'),
                        align:"center",
                        dataIndex: 'cmdParam'
                    },
                    {
                        title: this.$t('命令内容'),
                        align:"center",
                        dataIndex: 'cmdContent'
                    },
                    {
                        title: this.$t('发送时间'),
                        align:"center",
                        dataIndex: 'sendTime'
                    },
                    {
                        title: this.$t('接收时间'),
                        align:"center",
                        dataIndex: 'receiveTime'
                    },
                    {
                        title: this.$t('接收内容'),
                        align:"center",
                        dataIndex: 'receiveContent'
                    }
                ]
            },
        },
        methods: {
            edit(record) {
                this.visible = true;
                this.model = Object.assign(this.model,record)
                this.queryMeterFotaCommand()
            },
            queryMeterFotaCommand() {
                this.loading = true
                getAction(this.url.list, {meterId: this.model.meterId}).then((res)=> {
                    if(res.success) {
                        this.dataSource = res.result.records
                    }else{
                        this.$message.error(res.message)
                    }
                }).finally(()=> {
                    this.loading = false
                })
            },
            close () {
                this.$emit('close');
                this.mode = {};
                this.ipagination = this.$options.data.call(this).ipagination
                this.visible = false;
            },
            handleCancel() {
                this.close();
            },
        }
    }
</script>